<template>
	<svg
		:alt="alt"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 32 32"
	>
		<g transform="translate(1 1)" fill="#FFF" fill-rule="nonzero" stroke="#0074B5">
			<rect width="30" height="30" rx="2"/>
			<circle cx="7" cy="7" r="2"/>
			<circle cx="23" cy="7" r="2"/>
			<circle cx="15" cy="7" r="2"/>
			<circle cx="7" cy="23" r="2"/>
			<circle cx="15" cy="23" r="2"/>
			<circle cx="23" cy="23" r="2"/>
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
